/* import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import pdfimg from "../../../template/images/pdf-image.png";
import ShareButtons from '../../layout/shareButtons';

function RegulatoryUpdatesView() {
  const { id } = useParams();
  const [regulatoryData, setRegulatoryData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRegulatoryData = async () => {
      try {
        const response = await axios.get(`https://finlabsweb.finlabsindia.org/finlabs_quiz/api/regulatory-records/view/${id}`, {
          headers: {
            'Authorization': 'Bearer dGFuaWFfMjAyNC0wOC0wOA=='
          }
        });
        setRegulatoryData(response.data);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Error fetching data. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchRegulatoryData();
  }, [id]);

  const shareUrl = 'https://finlabsindia.org/';
  const title = 'Check out this amazing website!';

  return (
    <>
      <div className="reg-updates-view container">
        <div className="update-bredcrumb">
          Knowledge centre / Financial hub / Regulatory updates / <span>{regulatoryData?.regulatoryName}</span>
        </div>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p>{error}</p>
        ) : regulatoryData ? (
          <>
            <span className="club-line">{regulatoryData.regulatoryName}</span>
            <span>Legal Category: {regulatoryData.department}</span>
            <span>Notification Date: {regulatoryData.dateOfAmendment}</span>
            <span>Notification No: {regulatoryData.notificationNo}</span>
            <span>Description: {regulatoryData.description}</span>
            <span className="download-btn-sec">
              <button className="download-btn">Download <i className="fa fa-download"></i></button>
            </span>
            <span className="share-section">
              <ShareButtons url={shareUrl} title={title} />
            </span>
            <div className="pdf-img">
              <img src={pdfimg} alt="" />
            </div>
          </>
        ) : (
          <p>No data available.</p>
        )}
      </div>
    </>
  );
}

export default RegulatoryUpdatesView; */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import ShareButtons from '../../layout/shareButtons';
import { Modal, Button, Form } from "react-bootstrap";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import axiosInstance from "../../../util/axiosInstance";
import { Apiurl } from "../../../util/apiurl";

function RegulatoryUpdatesView() {
  const { id } = useParams();
  const [regulatoryData, setRegulatoryData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [captcha, setCaptcha] = useState(false);
  const [downloadError, setDownloadError] = useState("");
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfError, setPdfError] = useState(null);

  useEffect(() => {
    const fetchRegulatoryData = async () => {
      try {
        const response = await axiosInstance.get(
          `${Apiurl.view}${id}`
        );
        setRegulatoryData(response.data);
        if (response.data.pdfFile) {
          const pdfBlob = base64ToBlob(response.data.pdfFile, 'application/pdf');
          const pdfObjectUrl = URL.createObjectURL(pdfBlob);
          setPdfUrl(pdfObjectUrl);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Error fetching data. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchRegulatoryData();

    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [id]);

  const shareUrl = 'https://finlabsweb.finlabsindia.org/RegulatoryUpdates';
  const title = 'Check out this amazing website!';

  const base64ToBlob = (base64, type = 'application/pdf') => {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new Blob([bytes], { type: type });
  };

  const handleDownloadClick = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setDownloadError("");
  };

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
    setDownloadError("");
  };

  const handleCaptchaChange = (e) => {
    setCaptcha(e.target.checked);
    setDownloadError("");
  };

  const handleDownload = () => {
    if (!name || !email || !captcha) {
      setDownloadError("Please fill all fields and check the captcha.");
      return;
    }

    if (regulatoryData && regulatoryData.pdfFile) {
      const pdfBlob = base64ToBlob(regulatoryData.pdfFile, 'application/pdf');
      const downloadUrl = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = regulatoryData.pdfFileName || 'regulatory_update.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);
      setShowModal(false);
    } else {
      setDownloadError('PDF content not available');
    }
  };

  const renderPdf = () => {
    if (!pdfUrl) {
      return <div>No PDF preview available</div>;
    }

    return (
      <div style={{ height: '600px', overflow: 'auto', border: '1px solid #ccc' }}>
        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
          <Viewer
            fileUrl={pdfUrl}
            defaultScale={1}
            onError={(error) => {
              console.error("PDF viewer error:", error);
              setPdfError("Failed to load PDF");
            }}
          />
        </Worker>
      </div>
    );
  };

  return (
    <>
      <div className="reg-updates-view container">
        <div className="update-bredcrumb">
          Knowledge centre / Financial hub / Regulatory updates / <span>{regulatoryData?.regulatoryName}</span>
        </div>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p>{error}</p>
        ) : regulatoryData ? (
          <>
            <span className="club-line">{regulatoryData.regulatoryName}</span>
            <span>Legal Category: {regulatoryData.department}</span>
            <span>Notification Date: {regulatoryData.dateOfAmendment}</span>
            <span>Notification No: {regulatoryData.notificationNo}</span>
            <span>Description: {regulatoryData.description}</span>
            <span className="download-btn-sec">
              <button className="download-btn" onClick={handleDownloadClick}>Download <i className="fa fa-download"></i></button>
            </span>
            <span className="share-section">
              <ShareButtons url={shareUrl} title={title} />
            </span>
            <div className="pdf-content">
              {pdfError ? <div>Error: {pdfError}</div> : renderPdf()}
            </div>
          </>
        ) : (
          <p>No data available.</p>
        )}
      </div>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Download Regulatory Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formName" className="mb-3">
              <Form.Label>Name <span className="errmark">*</span></Form.Label>
              <Form.Control
                type="text"
                value={name}
                onChange={handleInputChange(setName)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formEmail" className="mb-3">
              <Form.Label>Email <span className="errmark">*</span></Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={handleInputChange(setEmail)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formCaptcha" className="mb-3 d-flex">
              <Form.Check
                type="checkbox"
                label="I'm not a robot"
                checked={captcha}
                onChange={handleCaptchaChange}
                required
              />
              <span className="errmark mx-1">*</span>
            </Form.Group>
            {downloadError && (
              <p className="text-danger">{downloadError}</p>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={handleDownload}
            disabled={!name || !email || !captcha}
            className="footer-main"
          >
            Download PDF
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default RegulatoryUpdatesView;